export default __webpack_public_path__ + "static/media/cx.e5097191.svg";